export function juOnFinishOrder(cart, items) {
  if (!window.juapp) return

  window.juapp(
    'order',
    cart.id,
    {
      total: cart.cart_total,
      subtotal: cart.subtotal,
      tax: cart.tax_amount,
      shipping: cart.estimated_shipping,
      currency:'USD',
    }
  );


  for (const item of items) {
    window.juapp(
      'orderItem',
      item.stock_number,
      {
        name: item.product_name,
        quantity: item.quantity,
        price: item.price,
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/ju_tracking.js